import Component from "@ember/component"
import { inject as service } from "@ember/service"
import findDocument from "cc-frontend/helpers/find-document"
export default class ImportLessonsSelectCourseRecentCourse extends Component {
  @service("ember-store")
  store

  @findDocument("recent.courseId", "course-summary")
  course

  @findDocument("recent.planbookId", "planbook-summary")
  planbook
}
